import React from "react";
import { Loader, Modal as RsModal } from "rsuite";
import "./findTutorStepGuide.scss";
import JennyFace from "assets/imgs/icons/JennyFace.svg";

function FindTutorStepGuide({ stepGuide, setStepGuide }) {
  const checkOpen = (num) => {
    if (stepGuide == num) return true;
    return false;
  };

  return (
    <>
      <RsModal
        open={checkOpen(1)}
        size="xs"
        backdrop="static"
        dialogClassName="FindTutor-stepGuide-modal"
      >
        <RsModal.Body className="modal-body px-0">
          <img src={JennyFace} alt="Jenny" className="avatar-img" />
          <div className="message-wrapper">
            <p>
              Hey, I am Jenny.
              <br /> Happy to see that you set up your profile successfully.
              <br /> Now, I will guide you throughout the entire process <br />
              of the dashboard screens.
            </p>
          </div>
        </RsModal.Body>
        <RsModal.Footer className="modal-footer">
          <button onClick={() => setStepGuide((prev) => prev + 1)}>
            Okay, Let's Get Started
          </button>
        </RsModal.Footer>
      </RsModal>
      <RsModal
        open={checkOpen(2)}
        size="xs"
        backdrop="static"
        dialogClassName="FindTutor-stepGuide-modal"
      >
        <RsModal.Body className="step-modal-body px-4">
          <img src={JennyFace} alt="Jenny" className="step-avatar-img" />
          <div className="step-message-wrapper">
            <p>
              <span className="primary-font">Step 1</span>
              <br /> Let’s find a personalized tutor for your preferred course
            </p>
          </div>
        </RsModal.Body>
        <RsModal.Footer className="modal-footer">
          <button onClick={() => setStepGuide((prev) => prev + 1)}>
            Find My Private Tutor
          </button>
        </RsModal.Footer>
      </RsModal>
      <RsModal
        open={checkOpen(5)}
        size="xs"
        backdrop="static"
        dialogClassName="FindTutor-stepGuide-modal"
      >
        <RsModal.Body className="step-modal-body px-4">
          <img src={JennyFace} alt="Jenny" className="step-avatar-img" />
          <div className="step-message-wrapper">
            <p className="mt-2">Choose any tutor profile from the list.</p>
          </div>
        </RsModal.Body>
        <RsModal.Footer className="modal-footer">
          <button onClick={() => setStepGuide((prev) => prev + 1)}>
            Okay, Got it.
          </button>
        </RsModal.Footer>
      </RsModal>
      <RsModal
        open={checkOpen(8)}
        size="xs"
        backdrop="static"
        dialogClassName="FindTutor-stepGuide-modal"
      >
        <RsModal.Body className="modal-body px-0">
          <img src={JennyFace} alt="Jenny" className="avatar-img" />
          <div className="message-wrapper">
            <p>
              Yay ! Now you understood how to <br />
              schedule a trial session through the dashboard.
              <br /> Let’s move on to the next step.
            </p>
          </div>
        </RsModal.Body>
        <RsModal.Footer className="modal-footer">
          <button onClick={() => setStepGuide((prev) => prev + 1)}>
            Proceed
          </button>
        </RsModal.Footer>
      </RsModal>
    </>
  );
}

export default FindTutorStepGuide;
